export const visit = (vm, at) => {
at({ "ja": { "pricing-page-components": { "phone-support": { "seePhoneNumber": "\u96FB\u8A71\u756A\u53F7\u3092\u78BA\u8A8D" } } } });
};